"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UICoreSticky = void 0;
class UICoreSticky {
    sticky(dataAttribute = 'data-sticky') {
        try {
            this.nodeList = document.querySelectorAll(`[${dataAttribute}]`);
        }
        catch (e) {
            console.log(e);
            return;
        }
        for (let i = 0; i < this.nodeList.length; i++) {
            const randomId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
            const dataAnchor = this.nodeList[i].getAttribute('data-top-anchor');
            if (Number(dataAnchor)) {
                this.scrollOffset = Number(dataAnchor) || 0;
            }
            else {
                const dataAnchorEl = document.querySelectorAll(dataAnchor);
                this.scrollOffset = dataAnchorEl.length > 0 ? dataAnchorEl[0].clientHeight : 0;
            }
            //Create sticky container
            const stickyContent = this.nodeList[i].outerHTML;
            document.querySelectorAll(`[${dataAttribute}]`)[i].outerHTML = `<div id="${randomId}" class='sticky__container'>${stickyContent}</div>`;
            window.addEventListener('scroll', () => {
                this.scrollPosition = window.pageYOffset;
                if (this.scrollPosition >= (this.scrollOffset + 1)) {
                    document.querySelectorAll(`[${dataAttribute}]`)[i].classList.add('is-stuck');
                    document.querySelectorAll(`[${dataAttribute}]`)[i].parentElement.style.height = document.querySelectorAll(`[${dataAttribute}]`)[i].clientHeight + 'px';
                    return;
                }
                document.querySelectorAll(`[${dataAttribute}]`)[i].classList.remove('is-stuck');
                document.querySelectorAll(`[${dataAttribute}]`)[i].parentElement.style.height = 'auto';
            });
        }
    }
}
exports.UICoreSticky = UICoreSticky;
